import { Button, Modal } from '@ixyberfree/ixybercomponents';
import * as hmiclientbase from 'components/hmilib/hmiclientbase';
import { ITreeAPC_branch } from 'components/MainControl/TreeAPC/TreeAPC';
import React from 'react';
import { colorText, ContentPopup, Input, MainText, Select } from 'styles';
import { styleCell, styleInput, styleRow, styleTable } from '../../styles';

interface IPropsAddBlockWindow {
    isButtonLoading: boolean;
    closeCM?: Function;
    createCB?: Function;
    listObj?: any;
    selectedBranch?: ITreeAPC_branch;
}

export const AddBlockWindow: React.FC<IPropsAddBlockWindow> = ({
    isButtonLoading,
    closeCM,
    createCB,
    listObj,
    selectedBranch
}) => {
    let [nameBlock, setNameBlock] = React.useState('');
    let [typeBlock, setTypeBlock] = React.useState('');
    let [keyObj, setKeyObj] = React.useState<string | null>(null);
    let [listKeyObj, setListKeyObj] = React.useState<string[]>([]);

    React.useEffect(() => {
        let listKey = [];
        if (listObj !== undefined) {
            for (let key in listObj) {
                if (Array.isArray(listObj[key]) && listObj[key].length > 0) {
                    listKey.push(key);
                }
            }
            setListKeyObj(listKey);
            if (listKey.length > 0) {
                setKeyObj(listKey[0]);
            }
            if (listObj !== undefined && listObj[listKey[0]].length > 0) {
                setTypeBlock(listObj[listKey[0]][0]);
            }
        }
    }, []);

    ///template
    let [templateBindings, setTemplateBindings] = React.useState<any>([]);
    let [newTemplateBindings, setNewTemplateBindings] = React.useState<any>({});

    React.useEffect(() => {
        if (keyObj?.toLowerCase() == 'template') {
            hmiclientbase.TemplateGetBinding(typeBlock).then((data: any) => {
                setTemplateBindings(data);
            });
        }
    }, [keyObj, typeBlock]);

    let changeTemplateBindings = function (key: string, value: string) {
        let bind = templateBindings.find((i: any) => i.name == key);
        if (bind) {
            if (bind.Value != value) {
                let updatedValue: any = {};
                updatedValue[key] = value;
                setNewTemplateBindings({
                    ...newTemplateBindings,
                    ...updatedValue
                });
            } else if (newTemplateBindings[key]) {
                let updatedValue: any = newTemplateBindings;
                delete updatedValue[key];
                setNewTemplateBindings(updatedValue);
            }
        }
    };

    const changeKeyObj = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setKeyObj(e.target.value);
        setTypeBlock('');
        if (listObj[e.target.value].length > 0) {
            setTypeBlock(listObj[e.target.value][0]);
        }
    };

    return (
        <Modal
            className="modal-window"
            headerLabel="Создать блок"
            width="15rem"
            onCloseClick={() => {
                closeCM && closeCM();
            }}>
            <ContentPopup
                style={{ display: 'flex', flexDirection: 'column', fontSize: '12px' }}
                onClick={(e) => e.stopPropagation()}>
                <MainText style={{ marginBottom: '5px' }} size={14} color={colorText.main}>
                    Имя блока
                </MainText>
                <Input
                    autoComplete="off"
                    onChange={(e) => {
                        setNameBlock(e.currentTarget.value);
                    }}
                    autoFocus
                />
                <MainText style={{ margin: '10px 0px 5px 0px' }} size={14} color={colorText.main}>
                    Стиль блока
                </MainText>
                <Select onChange={changeKeyObj}>
                    {listKeyObj?.map((type, ind) => {
                        return (
                            <option key={ind} value={type}>
                                {type}
                            </option>
                        );
                    })}
                </Select>
                <MainText style={{ margin: '10px 0px 5px 0px' }} size={14} color={colorText.main}>
                    Тип блока
                </MainText>
                <Select
                    onChange={(e) => {
                        setTypeBlock(e.target.value);
                    }}>
                    {keyObj !== null &&
                        listObj !== undefined &&
                        listObj[keyObj]?.map((type: any, ind: number) => {
                            if (selectedBranch?.path?.includes('TEMPLATES')) {
                                if (type != selectedBranch?.name) {
                                    return (
                                        <option key={ind} value={type}>
                                            {type}
                                        </option>
                                    );
                                }
                            } else {
                                return (
                                    <option key={ind} value={type}>
                                        {type}
                                    </option>
                                );
                            }
                        })}
                </Select>

                {keyObj?.toLowerCase() == 'template' && (
                    <div style={{ padding: '5px' }}>
                        <table style={styleTable}>
                            <tbody>
                                {templateBindings?.map((item: any, index: any) => {
                                    return (
                                        <tr style={styleRow} key={item.id}>
                                            <td style={styleCell}>{item.name}</td>
                                            <td style={styleCell}>
                                                <input
                                                    key={index}
                                                    name={item.name}
                                                    style={styleInput}
                                                    defaultValue={item.Value}
                                                    onChange={(e) => {
                                                        const { name, value } = e.target;
                                                        changeTemplateBindings(name, value);
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-around', paddingTop: '1em' }}>
                    <Button
                        text="Создать"
                        styleType="filled"
                        size="small"
                        isLoading={isButtonLoading}
                        onClick={() => {
                            createCB &&
                                createCB(
                                    nameBlock.trim().replace(/\s+/g, ' '),
                                    typeBlock,
                                    keyObj,
                                    JSON.stringify(newTemplateBindings)
                                );
                        }}
                        // width="100px"
                    />
                    <div style={{ width: '1.8em' }}></div>
                    <Button text="Отменить" styleType="tinted" size="small" onClick={() => closeCM && closeCM()} />
                </div>
            </ContentPopup>
        </Modal>
    );
};
